<script>
import router from "../routes";
import NavBarPublic from "@/components/nav-bar-public";
import SideBarPublic from "@/components/side-bar-public";

export default {
  components: { NavBarPublic, SideBarPublic },
  beforeCreate() {
    document.body.className = "main";
  },
  data() {
    return {
      isMenuCondensed: false,
    };
  },
  created() {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
  },
};
</script>

<template>
  <div id="layout-wrapper">
    <NavBarPublic />
    <SideBarPublic :isCondensed="isMenuCondensed" />
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
